/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_HintInputs */

const en_directory_ai_tools_studio_photo_hint = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front-facing, well-lit selfies work best. One face per photo; they don't need to be taken together.`)
};

const zh_directory_ai_tools_studio_photo_hint = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正脸、光线充足的自拍效果最好。每张只有一张脸，不需要是合照。`)
};

/**
* | output |
* | --- |
* | "Front-facing, well-lit selfies work best. One face per photo; they don't need to be taken together." |
*
* @param {Directory_Ai_Tools_Studio_Photo_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_hint = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_hint(inputs)
	return zh_directory_ai_tools_studio_photo_hint(inputs)
});
export { directory_ai_tools_studio_photo_hint as "directory.ai_tools.studio.photo_hint" }